import React from 'react'
import compose from 'recompose/compose'
// import { action } from 'mobx'
import { inject, observer } from 'mobx-react'
// import { Tooltip } from 'antd'
// import withRouting from '~/hocs/withRouting'
import _get from 'lodash/get'
import _findLast from 'lodash/findLast'
import moment from 'moment'
import { Marker } from 'react-google-maps'
import config from '~/config'
// import { Pin } from './styles'
const SALINITY = _get(config, 'app.parameters', []).find(p => p.name === 'ความเค็ม')

const Station = ({ data, view, station, main, salinityRecords }) => {
  // const setStation = action('setStation', sId => {
  //   // setQuery({ stationId: sId })
  //   view.stationId = sId
  // })
  const { mode, daysOffset } = view
  const today = moment(data.now).clone().set({ hour: 0, minute: 0, second: 0 })
  const currentDay = (mode === 'forecasting' || mode === 'scenario') ? today.clone().add(daysOffset, 'day') : today
  const salinity = _findLast(salinityRecords, rec => currentDay.isSame(moment(rec.observedTimestamp), 'day'))

  //   const salinity =_get(_orderBy(salinityRecords, ['observedTimestamp'],['desc']),0)
  let color // eslint-disable-line no-unused-vars
  if (salinity) {
    if (salinity.value > 0) {
      SALINITY.scales.forEach(([value, c]) => {
        if (salinity.value >= value) {
          color = c
        }
      })
    }
  }
  // console.log({ color })
  const title = salinity
    ? `${station.stationName} (${SALINITY.name}: ${salinity.value} ${SALINITY.unit})
    @${salinity.observedTimestamp}`
    : station.stationName
  return <Marker
    icon={{
      path: main
      //        ? 'M22-48h-44v43h16l6 5 6-5h16z'
        ? 'M0-48c-9.8 0-17.7 7.8-17.7 17.4 0 15.5 17.7 30.6 17.7 30.6s17.7-15.4 17.7-30.6c0-9.6-7.9-17.4-17.7-17.4z'
        : 'M0-48c-9.8 0-17.7 7.8-17.7 17.4 0 15.5 17.7 30.6 17.7 30.6s17.7-15.4 17.7-30.6c0-9.6-7.9-17.4-17.7-17.4z',
      fillColor: color,
      fillOpacity: 0.7,
      strokeColor: 'black',
      strokeWeight: main ? 1 : 0
    }}
    // icon={main ? { url: '/public/main_marker.png' } : null }
    onClick={() => view.setStationIds([station.id])}
    position={{ lat: station.latitude, lng: station.longitude }}
    label={station.stationName}
    title={title}
    // onMouseOver={(...x) => console.log('over', x)}
    // onMouseOut={(...x) => console.log('out', x)}
  >
  </Marker>
  // return <Tooltip title={title}>
  //   <Pin onClick={() => setStation(station.id)} main={main} color={color}/>
  // </Tooltip>
}

export default compose(
  // withRouting,
  inject('data'),
  inject('view'),
  observer
)(Station)



// WEBPACK FOOTER //
// ./src/components/Station.js